import { VFC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

type Props = {
  isAlertDialogOpen: boolean;
  title: string;
  message: string;
  mode: string;
  handleAlertCancel: () => void;
  handleAlertOk: () => void;
};

/**
 * 確認ダイアログ
 * @param param0
 * @returns
 */
export const AlertDialog: VFC<Props> = ({
  isAlertDialogOpen,
  title,
  message,
  mode,
  handleAlertCancel,
  handleAlertOk,
}) => {
  return (
    <>
      <Dialog open={isAlertDialogOpen}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAlertCancel}>キャンセル</Button>
          <Button onClick={handleAlertOk}>{mode}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
